// React
import React from 'react';

// Vendors
import { Outlet, Navigate } from 'react-router-dom';

// Src
import { useAuthentication } from '@/domain/authentication/hooks/useAuthentication';
import useSessionManager from '@/domain/authentication/hooks/useSessionManager';

const ProtectedRoute = () => {
    // Hooks
    const { loggedIn } = useAuthentication();
    const handleSetActivityUserActive = useSessionManager();

    if (!loggedIn) {
        return <Navigate to="/login" />;
    }

    return (
        <div
            onMouseDown={() => loggedIn && handleSetActivityUserActive()}
            onKeyDown={() => loggedIn && handleSetActivityUserActive()}
        >
            <Outlet />
        </div>
    );
};

export default ProtectedRoute;
